import { michiganKickerSharedAssetPreloader } from '../shared/asset-preloader'

export enum MI_MULTIPLIER_GUMBALL_ATLAS_FRAMES {
  BACKGROUND = 'background.png',
  BALL_PREFIX = 'ball-',
  BALL_PILE = 'ball-pile.png',
  BALL_BLURRY = 'blur.png',
  COIN = 'coin.png',
  COIN_MASK = 'coin-mask.png',
  FLAP = 'flap.png',
  KEY = 'key.png',
  MACHINE = 'machine.png',
  SHINE = 'flash.png',
  SPIRAL = 'spiral.png',
  SPIRAL_MASK = 'spiral-mask.png',
}

export enum MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS {
  ATLAS = 'MI_MULTIPLIER_GUMBALL_ATLAS',
}

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/gumball/`

  michiganKickerSharedAssetPreloader(scene)

  if (!scene.textures.getTextureKeys().includes(MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS)) {
    scene.load.multiatlas(
      MI_MULTIPLIER_GUMBALL_TEXTURE_KEYS.ATLAS,
      `${prefix}atlas/multiplier-gumball-images.json`,
      `${prefix}atlas/`,
    )
  }
}
